/**
 * Convert ISO 3166-1 alpha-2 country code to flag emoji
 * @param countryCode - Two-letter country code (e.g., 'US', 'PL', 'BY')
 * @returns Flag emoji or empty string if invalid
 */
export const getCountryFlag = (countryCode: string | null | undefined): string => {
  if (!countryCode || countryCode.length !== 2) {
    return '';
  }

  // Convert country code to uppercase
  const code = countryCode.toUpperCase();

  // Convert to regional indicator symbols (Unicode flag emojis)
  // A = 0x1F1E6, so offset from 'A' (65) to get the right emoji
  const codePoints = [...code].map((char) => 0x1F1E6 + char.charCodeAt(0) - 65);

  return String.fromCodePoint(...codePoints);
};
